"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeechToTextServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
let SpeechToTextService = class SpeechToTextService extends client_1.RWSService {
    constructor(apiService) {
        super();
        this.apiService = apiService;
    }
    /**
     * Transcribe audio blob to text
     */
    async transcribeAudio(audioBlob, language = 'en', sessionId) {
        try {
            // Use native fetch for FormData uploads
            const formData = new FormData();
            formData.append('audio', audioBlob, 'recording.webm');
            if (language) {
                formData.append('language', language);
            }
            if (sessionId) {
                formData.append('sessionId', sessionId);
            }
            const response = await fetch('/api/audio/speech-to-text', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.apiService.token}`
                },
                body: formData
            });
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            const result = await response.json();
            return result;
        }
        catch (error) {
            console.error('Failed to transcribe audio:', error);
            return {
                success: false,
                error: error.message || 'Failed to transcribe audio'
            };
        }
    }
    /**
     * Transcribe audio file
     */
    async transcribeFile(file, language = 'en', sessionId) {
        try {
            const formData = new FormData();
            formData.append('audio', file);
            if (language) {
                formData.append('language', language);
            }
            if (sessionId) {
                formData.append('sessionId', sessionId);
            }
            const response = await fetch('/api/audio/speech-to-text', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.apiService.token}`
                },
                body: formData
            });
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            const result = await response.json();
            return result;
        }
        catch (error) {
            console.error('Failed to transcribe file:', error);
            return {
                success: false,
                error: error.message || 'Failed to transcribe file'
            };
        }
    }
    /**
     * Get supported languages for transcription
     */
    getSupportedLanguages() {
        return [
            'en', 'es', 'fr', 'de', 'it', 'pt', 'pl', 'tr', 'ru', 'nl', 'cs', 'ar', 'zh', 'ja', 'hu', 'ko'
        ];
    }
    /**
     * Validate audio file for transcription
     */
    validateAudioFile(file) {
        const maxSize = 25 * 1024 * 1024; // 25MB
        const supportedTypes = [
            'audio/wav', 'audio/mp3', 'audio/mpeg', 'audio/mp4', 'audio/m4a',
            'audio/webm', 'audio/ogg', 'audio/flac'
        ];
        if (file.size > maxSize) {
            return {
                valid: false,
                error: 'File size exceeds 25MB limit'
            };
        }
        if (!supportedTypes.includes(file.type)) {
            return {
                valid: false,
                error: `Unsupported file type: ${file.type}. Supported types: ${supportedTypes.join(', ')}`
            };
        }
        return { valid: true };
    }
};
exports.SpeechToTextServiceInstance = SpeechToTextService;
exports.SpeechToTextServiceInstance = SpeechToTextService = __decorate([
    __param(0, client_1.ApiService),
    __metadata("design:paramtypes", [typeof (_a = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _a : Object])
], SpeechToTextService);
exports.default = SpeechToTextService.getSingleton();
